// Generated from SVG to Code Figma Plugin

import type React from 'react';
import { cn } from '@/app/utils';

interface BaseLineT2atipProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

export const BaseLineT2atip = ({ isActive, className, ...props }: BaseLineT2atipProps) => (
  <svg
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className)}
    style={{ overflow: 'hidden' }}
    {...props}
  >
    <defs>
      <clipPath id="bookmarkClip">
        <path
          d={
            isActive
              ? 'M10.7246 13.5V5.5H15.8246V13.5L13.2746 10.0L10.7246 13.5Z'
              : 'M10.7246 11.15V3.5H15.8246V11.15L13.2746 8.4841L10.7246 11.15Z'
          }
        />
      </clipPath>
    </defs>

    <path
      d="M4.77383 20.5C4.30439 20.5 3.92383 20.1195 3.92383 19.65V4.35C3.92383 3.88056 4.30439 3.5 4.77383 3.5H19.2238C19.6933 3.5 20.0738 3.88056 20.0738 4.35V19.65C20.0738 20.1195 19.6933 20.5 19.2238 20.5H4.77383Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      style={{ zIndex: 20 }}
    />

    <path
      d="M10.7246 11.15V3.5H15.8246V11.15L13.2746 8.4841L10.7246 11.15Z"
      className={isActive ? 'opacity-0' : 'opacity-100'}
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      style={{
        transition: 'opacity 0.3s ease',
      }}
    />

    <g clipPath="url(#bookmarkClip)" style={{ zIndex: 5 }}>
      <rect
        x={isActive ? '10.7246' : '10.7246'}
        y={isActive ? '5.5' : '3.5'}
        width={isActive ? '5.1' : '5.1'}
        height={isActive ? '8' : '7.65'}
        className={isActive ? 'opacity-100' : 'opacity-0'}
        fill="#0086FF"
        style={{
          transition: 'opacity 0.3s ease',
          transformOrigin: 'center top',
          animation: isActive ? 'slideInDown 0.3s ease forwards' : 'slideOutUp 0.3s ease forwards',
        }}
      />
    </g>

    <path
      d={
        isActive
          ? 'M10.7246 13.5V5.5H15.8246V13.5L13.2746 10.0L10.7246 13.5Z'
          : 'M10.7246 11.15V3.5H15.8246V11.15L13.2746 8.4841L10.7246 11.15Z'
      }
      className={isActive ? 'opacity-100' : 'opacity-0'}
      fill="none"
      stroke="#0086FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      style={{
        transition: 'opacity 0.3s ease',
        zIndex: 10,
      }}
    />

    <path
      d="M4.77383 20.5C4.30439 20.5 3.92383 20.1195 3.92383 19.65V4.35C3.92383 3.88056 4.30439 3.5 4.77383 3.5H19.2238C19.6933 3.5 20.0738 3.88056 20.0738 4.35V19.65C20.0738 20.1195 19.6933 20.5 19.2238 20.5H4.77383Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      style={{ zIndex: 30, pointerEvents: 'none' }}
      fill="none"
    />

    <style jsx>{`
      @keyframes slideInDown {
        from {
          transform: translateY(-100%);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @keyframes slideOutUp {
        from {
          transform: translateY(0);
          opacity: 1;
        }
        to {
          transform: translateY(-100%);
          opacity: 0;
        }
      }
    `}</style>
  </svg>
);
